import React from 'react';
import { ReactElement } from 'react';
import { AboutPage } from './pages/About';
import { HomePage } from './pages/Home';
import { ParentPage } from './pages/About/Parent/Parent.page';
import { AthletePage } from './pages/About/Athlete/Athlete.page';
import { CoachPage } from './pages/About/Coach/Coach.page';
import { GetHelpPage } from './pages/GetHelp/GetHelp.page';
import { ResearchPage } from './pages/Research/Research.page';
import { ContactUsPage } from './pages/ContactUs/ContactUs.page';
import { PrivacyPage } from './pages/Privacy/PrivacyPage';
import { FaqPage } from './pages/Faq/Faq.page';
import { TermsConditionsPage } from './pages/TermsConditions/TermsConditionsPage';

export interface NavigationLink {
  title: string;
  link: string;
  external?: boolean;
}

export interface AppRoute {
  path: string;
  element: ReactElement;
}

export const appRoutes: AppRoute[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/whositfor/parent', element: <ParentPage /> },
  { path: '/whositfor/athlete', element: <AthletePage /> },
  { path: '/whositfor/coach', element: <CoachPage /> },
  { path: '/gethelp', element: <GetHelpPage /> },
  { path: '/research', element: <ResearchPage /> },
  { path: '/signup', element: <ContactUsPage /> },
  { path: '/contact', element: <ContactUsPage /> },
  { path: '/faq', element: <FaqPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/terms', element: <TermsConditionsPage /> }
];

export const headerNavLinks: NavigationLink[] = [
  { title: "Who's it for?", link: '/#whositfor' },
  { title: 'About', link: '/about' },
  { title: 'FAQ', link: '/faq' },
  { title: 'Get help', link: '/gethelp' },
  { title: 'Contact', link: '/contact' },
  { title: 'Research', link: '/research' }
];

export const whoIsThisForNavLinks: NavigationLink[] = [
  { title: 'Athletes', link: '/whositfor/athlete' },
  { title: 'Parents', link: '/whositfor/parent' },
  { title: 'Coaches', link: '/whositfor/coach' }
];

export const footerNavLinks: NavigationLink[] = [
  { title: 'Get help', link: '/gethelp' },
  { title: 'Contact', link: '/contact' },
  { title: 'Terms & Conditions', link: '/terms' },
  { title: 'Privacy Statement', link: '/privacy' }
];
